import React from "react";
import styles from "../styles/menus-evento.module.css";

export default function MenusFiltersBar({
    query, onQuery,
    dateFrom, onDateFrom,
    dateTo, onDateTo,
    estado, onEstado,
    sortBy, onSortBy,
}) {
    return (
        <div className={styles["filters-row"]}>
            <div className={styles["filters-bar"]}>
                <span className={styles["filters-label"]}>Filtros</span>
                <input
                    className={styles.input}
                    placeholder="Buscar por evento o menú…"
                    value={query}
                    onChange={(e) => onQuery(e.target.value)}
                />
                <div className={styles.dates}>
                    <input className={styles.input} type="date" value={dateFrom} onChange={(e) => onDateFrom(e.target.value)} />
                    <span className={styles.tilde}>→</span>
                    <input className={styles.input} type="date" value={dateTo} onChange={(e) => onDateTo(e.target.value)} />
                </div>
                <select className={styles.input} value={estado} onChange={(e) => onEstado(e.target.value)}>
                    <option value="todos">Todos</option>
                    <option value="pasados">Pasados</option>
                    <option value="actuales">En curso</option>
                    <option value="futuros">Futuros</option>
                </select>
            </div>

            <div className={`${styles["filters-bar"]} ${styles["sort-bar"]}`}>
                <span className={styles["filters-label"]}>Ordenación</span>
                <select className={styles.input} value={sortBy} onChange={(e) => onSortBy(e.target.value)}>
                    <option value="inicio">Orden: Fecha inicio</option>
                    <option value="nombre">Orden: Nombre evento</option>
                </select>
            </div>
        </div>
    );
}
